<template>
  <div
    id="app"
    class="h-100"
    :class="[skinClasses]"
  >
    <component :is="layout">
      <router-view />
    </component>

    <scroll-to-top v-if="enableScrollToTop" />
  </div>
</template>

<script>
import ScrollToTop from '@core/components/scroll-to-top/ScrollToTop.vue'

// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { provideToast } from 'vue-toastification/composition'
import { watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

import { useWindowSize, useCssVar } from '@vueuse/core'
// import store from '@/store'

const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')
import RestApi, { studyPressBaseUrl } from '@/config/api_config'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'

export default {
  store,
	router,
  i18n,
  components: {

    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,

    ScrollToTop,
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
  },
  beforeCreate() {
    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },
  created() {
    // window.addEventListener('beforeunload', (e) => {
    //       e.preventDefault();
    //       console.log('e===', e)
    //       console.log('e.preventDefault()', e.preventDefault())
    //       alert('Close tab alert')
    //       this.updateAuthLoginData()
    //       e.returnValue = 'Are you sure to close tab?';
    //   }, false)
  },
  methods: {
    updateAuthLoginData: async function () {
        try {
          this.loading = true
          const result = await RestApi.postData(studyPressBaseUrl, `api/v1/ajax/update_auth_user_login_data`)
          this.loading = false
  
        } catch (error) {
          this.loading = false
        }
      },
  },
  setup() {
    const { skin, skinClasses } = useAppConfig()
    const { enableScrollToTop } = $themeConfig.layout

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
      enableScrollToTop,
    }
  },
  beforeDestroy: function() {
      // console.log("Stopping the interval timer")
      // clearInterval(this.twoSecondsTimerEvents)
      // this.updateAuthLoginData()
  }
}
</script>

<style lang="scss">
  body{
    font-size: 13px !important;
  }
  .question_list li {
    font-size: 13px !important;
  }
  .custom-checkbox .custom-control-label, .custom-radio .custom-control-label {
    font-size: 13px !important;
  }
  .swal2-actions {
    button{
      margin: 10px !important;
    }
  }
  .icon_position {
    position: absolute;
    margin-left: 278px;
    font-size: 25px;
    margin-top: -24px;
  }
  .css-button {
    font-family: Arial !important;
    color: #FFFFFF !important;
    font-size: 13px !important;
    border-radius: 50px !important;
    border: 0px #84bcf3 solid !important;
    padding: 15px 64px !important;
    background: linear-gradient(101deg, #4dcaf7 0%, #6e3bcc 100%) !important;
    text-shadow: 0px 0px 0px #030303 !important;
    box-shadow: inset 0px 0px 0px 0px #bbdaf7 !important;
    cursor: pointer !important;
    display: inline-flex !important;
    align-items: center !important;
    font-weight: 800 !important;
  }
  .css-button:hover {
    // background: linear-gradient(101deg, #979c9e 0%, #6e3bcc 100%);
    background: linear-gradient(101deg, #6e3bcc 0%, #4dcaf7 100%);
    color: #FFF;
  }
  // .swal2-popup swal2-modal swal2-icon-warning swal2-show
  .swal2-popup {
    display: inline !important;
  }

  .text-bold-300{ font-weight: 300; }
.text-bold-400{ font-weight: 400; }
.text-bold-500{ font-weight: 500; }
.text-bold-600{ font-weight: 600; }
.text-bold-700{ font-weight: 700; }
.text-bold-800{ font-weight: 800; }
.text-bold-900{ font-weight: 900; }

.font-size-10 { font-size: 10px !important; }
.font-size-11 { font-size: 11px !important; }
.font-size-12 { font-size: 12px !important; }
.font-size-13 { font-size: 13px !important; }
.font-size-14 { font-size: 14px !important; }
.font-size-15 { font-size: 15px !important; }
.font-size-16 { font-size: 16px !important; }
.font-size-18 { font-size: 18px !important; }
.font-size-20 { font-size: 20px !important; }
.font-size-22 { font-size: 22px !important; }
.font-size-24 { font-size: 24px !important; }
.font-size-26 { font-size: 26px !important; }
.font-size-28 { font-size: 28px !important; }
.font-size-30 { font-size: 30px !important; }
.font-size-32 { font-size: 32px !important; }
.font-size-34 { font-size: 34px !important; }
.font-size-36 { font-size: 36px !important; }
.font-size-38 { font-size: 38px !important; }

.underline { text-decoration: underline !important; }
.underline-2 { text-decoration: underline !important; text-decoration-thickness: 2px !important; }
.underline-3 { text-decoration: underline !important; text-decoration-thickness: 3px !important; }
.underline-4 { text-decoration: underline !important; text-decoration-thickness: 4px !important; }
.underline-5 { text-decoration: underline !important; text-decoration-thickness: 5px !important; }
</style>